"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOrganisationDisplayName;

function getOrganisationDisplayName(_ref) {
  var name = _ref.name,
      status = _ref.status;

  if (status !== 'DRAFT') {
    return name;
  }

  return "[DRAFT] ".concat(name);
}